import 'babel-polyfill'
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from './App';
import router from './router';
import store from './store';
// import GEE from 'gee-ui/dist/gee';
import sensors from 'sa-sdk-javascript';
import GeeUI from 'geetest-ui'
// Vue.use(GEE);
// import 'gee-ui/dist/styles/gee.css'
import 'styles/index.less'; // 全局自定义的主题样式

import 'geetest-ui/GeeUI.css'
Vue.use(GeeUI)

import i18n from './lang'

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');

// ----------- 部署神策 ---------
sensors.init({
    server_url: 'https://geetest.datasink.sensorsdata.cn/sa?project=production&token=0e26eb5332ec07c1',
    web_url: 'https://geetest.cloud.sensorsdata.cn',
    show_log: false,
    cross_subdomain: true,
    is_track_single_page: true,
    heatmap: {
        // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
        // 需要 JSSDK 版本号大于 1.7
        clickmap: 'default',
        // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
        // 需要 JSSDK 版本号大于 1.9.1
        scroll_notice_map: 'default'
    },
    is_track_latest: {
    // 是否采集$latest_utm最近一次广告系列相关参数，默认值true
        utm: true,
        // 是否采集$latest_traffic_source_type最近一次流量来源类型，默认值true
        traffic_source_type: true,
        // 是否采集$latest_search_keyword最近一次搜索引擎关键字，默认值true
        search_keyword: true,
        // 是否采集$latest_referrer最近一次前向地址，默认值true
        referrer: true,
        // 是否采集$latest_referrer_host最近一次前向地址，默认值true
        referrer_host: true,
        // 是否采集$latest_landing_page最近一次落地页地址，默认值false
        landing_page: true
    }
});

sensors.quick('isReady', () => {
    // const id = sensors.store.getDistinctId();
    // console.log(`id:${id}`);
    // 如果前端已经调用过 login 方法,请使用这个方法获取匿名 id：sensors.store.getFirstId();
});
sensors.quick('autoTrack');
// sensors.setOnceProfile({
//     co_name: '',
//     product_name: ''
// });
sensors.registerPage({
    platform: 'Web',
    prod_name: 'gt-account',
    is_loged: false
});

window.sensors = sensors;

// ----------- end --------

// 海外客户报障多故下掉，后续需要统计再加上
const baiduTongji = () => {
    window._hmt = window._hmt || [];
    // let sc;
    // (function () {
    //     if ((sc = document.getElementById('baidu'))) {
    //         document.head.removeChild(sc);
    //     }
    //     let hm = document.createElement('script');
    //     hm.src = "https://hm.baidu.com/hm.js?25b04a5e7a64668b9b88e2711fb5f0c4";
    //     hm.id = 'baidu';
    //     let s = document.getElementsByTagName('script')[0];
    //     s.parentNode.insertBefore(hm, s);
    // })();
}
baiduTongji();

const googleTagManager = () => {
    (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", "GTM-5LS7WVP");
};

if(store.state.Gtlang && store.state.Gtlang.indexOf('en') != -1) {
    googleTagManager()
}
router.beforeEach((to, from, next)=> {
    if(to.path){
        baiduTongji();
        if(store.state.Gtlang && store.state.Gtlang.indexOf('en') != -1) {
            googleTagManager()
        }
        _hmt && _hmt.push(['_trackPageview', '/' + to.fullPath])
    }
    next()
})






// WEBPACK FOOTER //
// ./src/main.js